import React from "react";

export default function HelloWorld({ name = "world" }) {
  return (
    <div className="text-green-600 font-mono text-lg">
      hello, {name} — react is mounted.
    </div>
  );
}
